<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form :model="queryParams" ref="queryForm" size="small" label-width="80px">
          <el-row :gutter="24" type="flex">
            <el-col :span="4">
              <el-form-item label="客户名称" prop="compNames">
                <el-input v-model="queryParams.compNames" placeholder="请输入客户名称" @keyup.enter.native="handleQuery" />
                <CustomerDetails v-model="queryParams.compNames" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="使用单位" prop="usingUnit">
                <el-input v-model="queryParams.usingUnit" placeholder="请输入使用单位" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="小区名称" prop="houseName">
                <el-input v-model="queryParams.houseName" placeholder="请输入小区名称" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="识别码" prop="OIDNO">
                <el-input v-model="queryParams.OIDNO" placeholder="请输入识别码" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="打印状态" prop="isPrinted">
                <el-select v-model="queryParams.isPrinted" placeholder="请选择打印状态" clearable style="width: 100%;" @change="handleQuery">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="已打印" value="1"></el-option>
                  <el-option label="未打印" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="邮寄状态" prop="isMailed">
                <el-select v-model="queryParams.isMailed" placeholder="请选择邮寄状态" clearable style="width: 100%;" @change="handleQuery">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="已邮寄" value="1"></el-option>
                  <el-option label="未邮寄" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" type="flex">
            <el-col :span="4">
              <el-form-item label="上传状态" prop="ispinfoSubmitState">
                <el-select v-model="queryParams.ispinfoSubmitState" placeholder="请选择上传状态" clearable style="width: 100%;" @change="handleQuery">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="已上传" value="0"></el-option>
                  <el-option label="未上传" value="1"></el-option>
                  <el-option label="上传失败" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="到检年月" prop="inspectionMonthList">
                <el-date-picker v-model="queryParams.inspectionMonthList" type="months" placeholder="请选择到检年月" clearable value-format="yyyy-MM" style="width: 100%;" @change="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="回款状态" prop="receiptStatus">
                <el-select v-model="queryParams.receiptStatus" placeholder="请选择回款状态" style="width: 100%;" @change="handleQuery">
                  <el-option label="全部" :value="null" />
                  <el-option label="已回款" :value="1" />
                  <el-option label="未回款" :value="-1" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="数据上传时间" label-width="100px" prop="ispinfoSubmitTimeRange">
                <el-date-picker v-model="queryParams.ispinfoSubmitTimeRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd" clearable style="width: 100%;" @change="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="现场联系人及电话" prop="siteContactKeyword" label-width="180px">
                <el-input v-model="queryParams.siteContactKeyword" placeholder="请输入现场联系人及电话" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" type="flex">
            <el-col :span="4">
              <el-form-item label="邮寄日期" prop="mailingDateRange" >
                <el-date-picker v-model="queryParams.mailingDateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd" clearable style="width: 100%;" @change="handleQuery" />
              </el-form-item>
            </el-col>
          </el-row>
          <div style="text-align: center; margin-bottom: 10px;">
            <!-- <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">查询</el-button> -->
            <!-- <el-button icon="el-icon-refresh" size="small" @click="handleReset">重置</el-button> -->
            <!-- <el-button type="success" icon="el-icon-printer" size="small" @click="handleBatchPrint" :disabled="selectedRows.length === 0">报告打印</el-button>
            <el-button type="warning" icon="el-icon-download" size="small" @click="handleBatchDownload" :disabled="selectedRows.length === 0">报告下载</el-button>
            <el-button type="primary" icon="el-icon-s-promotion" size="small" @click="handleMailingRegister" :disabled="selectedRows.length === 0">报告邮寄登记</el-button> -->
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleQuery="handleQuery" @handleBatchPrint="handleBatchPrint" @handleBatchDownload="handleBatchDownload"
                                     @handleMailingRegister="handleMailingRegister" />
          </div>
          <!-- 表格 -->
          <el-table :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }" v-loading="loading"
                    element-loading-text="正在查询数据..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" row-key="id" @selection-change="handleSelectionChange"
                    height="500">
            <el-table-column type="selection" width="55" fixed="left" align="left"></el-table-column>
            <el-table-column type="index" label="序号" width="60" align="left" fixed="left" :index="indexMethod"></el-table-column>
            <el-table-column label="客户名称" align="left" prop="compName" min-width="160" show-overflow-tooltip fixed="left"></el-table-column>
            <el-table-column label="使用单位" align="left" prop="usingUnit" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column label="小区名称" align="left" prop="houseName" min-width="150" show-overflow-tooltip></el-table-column>
            <!-- ispinfoSubmitTime 数据上传时间 列 -->
            <el-table-column label="数据上传时间" align="left" prop="ispinfoSubmitTime" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="业务联系人及电话" align="left" min-width="150" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ scope.row.contactPerson }}/{{ scope.row.contactTel }}</span>
              </template>
            </el-table-column>
            <el-table-column label="识别码" align="left" prop="OIDNO" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="到检年月" align="left" prop="inspectionMonth" min-width="100" show-overflow-tooltip></el-table-column>
            <!-- receiptStatus 回款状态 列 -->
            <el-table-column label="回款状态" align="left" prop="receiptStatus" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.receiptStatus === 1">已回款</span>
                <span v-else-if="scope.row.receiptStatus === -1">未回款</span>
                <span v-else-if="scope.row.receiptStatus === null">全部</span>
                <span v-else>-</span>
              </template>
            </el-table-column>

            <el-table-column label="现场联系人及联系电话" align="left" prop="siteContact" min-width="220" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ scope.row.siteContact }}/{{ scope.row.siteContactTel }}</span>
              </template>
            </el-table-column>
            <el-table-column label="打印日期" align="left" prop="printDate" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="打印人" align="left" prop="printerEmployeeName" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="常用邮寄信息" align="left" prop="mailingInfo" min-width="300" show-overflow-tooltip></el-table-column>
            <el-table-column label="邮寄日期" align="left" prop="mailingDate" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="上传状态" align="left" prop="ispinfoSubmitState" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-tag v-if="scope.row.ispinfoSubmitState === '0'" type="success" size="small">已上传</el-tag>
                <el-tag v-else-if="scope.row.ispinfoSubmitState === '1'" type="info" size="small">未上传</el-tag>
                <el-tag v-else-if="scope.row.ispinfoSubmitState === '2'" type="danger" size="small">上传失败</el-tag>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <!-- 委托编号列 -->
            <el-table-column label="委托编号" align="left" prop="entrustNum" min-width="180" show-overflow-tooltip></el-table-column>
            <!-- <el-table-column label="操作" align="left" width="100" fixed="right">
              <template slot-scope="scope">
                <el-button type="danger" icon="el-icon-close" size="mini" @click="handleExit(scope.row)">退出</el-button>
              </template>
            </el-table-column> -->
          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currPage" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="queryParams.pageSize"
                         layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-form>
      </el-col>
    </el-row>

    <!-- 引入报告邮寄登记组件 -->
    <MailingRegister ref="mailingRegister" @refresh="getList" />

    <!-- 批量下载前参数填写对话框 -->
    <el-dialog title="批量下载设置" :visible.sync="downloadDialogVisible" width="500px" append-to-body>
      <el-form :model="downloadForm" :rules="downloadRules" ref="downloadForm" label-width="100px" size="small">
        <el-form-item label="是否打印" prop="isPrinted">
          <el-radio-group v-model="downloadForm.isPrinted">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="打印人" prop="printerEmployeePid">
          <el-select v-model="downloadForm.printerEmployeePid" placeholder="请选择打印人" filterable style="width: 100%;" :loading="employeeLoading" @focus="loadEmployeeList">
            <el-option v-for="employee in employeeList" :key="employee.employeePid" :label="employee.employeeName" :value="employee.employeePid" />
          </el-select>
        </el-form-item>
        <el-form-item label="打印日期" prop="printDate">
          <el-date-picker v-model="downloadForm.printDate" type="date" placeholder="请选择打印日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 100%;" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="downloadDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="downloadSubmitting" @click="confirmBatchDownload">确 定</el-button>
      </span>
    </el-dialog>

    <!-- PDF预览对话框 -->
    <el-dialog title="报告预览" :visible.sync="pdfPreviewVisible" width="80%" append-to-body>
      <PdfImgViewer ref="pdfImgViewer" :fileName="pdfFileName" :entrustNums="currentEntrustNums" :updatePrintInfoApi="handleUpdatePrintInfo" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="pdfPreviewVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MailingRegister from './add.vue';
import PdfImgViewer from '@/components/pdfview/PdfImgViewer.vue';
// TODO: 导入API方法
import { queryReportPrintMail, previewTestDataPdf, previewTestDataPdfdown, updatePrintInfo, queryEmployee } from '@/api/contract/contract';

export default {
  name: 'ReportAndMailing',
  components: {
    MailingRegister,
    PdfImgViewer
  },
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 显示搜索条件
      showSearch: true,
      // 表格数据
      tableData: [],
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        currPage: 1,
        pageSize: 200,
        compNames: undefined,
        usingUnit: undefined,
        houseName: undefined,
        OIDNO: undefined,
        inspectionMonthList: [],
        isPrinted: '0',
        isMailed: '0',
        ispinfoSubmitState: '0',
        receiptStatus: null,
        ispinfoSubmitTimeRange: [],
        mailingDateRange: []
      },
      // 选中的行
      selectedRows: [],
      // PDF预览相关
      pdfPreviewVisible: false,
      pdfFileName: '',
      // 当前预览的委托编号列表
      currentEntrustNums: [],
      // 批量下载相关
      downloadDialogVisible: false,
      downloadSubmitting: false,
      downloadEntrustNums: [],
      downloadForm: {
        isPrinted: '1', // 是否打印，1是/0否
        printerEmployeePid: '', // 打印人
        printDate: '' // 打印日期 yyyy-MM-dd
      },
      downloadRules: {
        isPrinted: [{ required: true, message: '请选择是否打印', trigger: 'change' }],
        printerEmployeePid: [{ required: true, message: '请选择打印人', trigger: 'change' }],
        printDate: [{ required: true, message: '请选择打印日期', trigger: 'change' }]
      },
      employeeList: [],
      employeeLoading: false
    };
  },
  created () {
    this.getList();
    // 预加载职员列表用于批量下载打印人选择
    this.loadEmployeeList();
  },
  methods: {
    // 计算序号（考虑分页）
    indexMethod (index) {
      return (this.queryParams.currPage - 1) * this.queryParams.pageSize + index + 1;
    },
    // 查询列表
    getList () {
      this.loading = true;

      queryReportPrintMail(this.queryParams).then(res => {
        if (res && res.dataList) {
          this.tableData = res.dataList || [];
          this.queryParams.currPage = res.curPage || this.queryParams.currPage;
          this.queryParams.pageSize = res.pageSize || this.queryParams.pageSize;
          this.total = res.totalRowNum || 0;
        } else {
          this.$message.error('获取列表失败');
        }
        this.loading = false;
      }).catch(error => {
        console.error('获取列表失败:', error);
        this.loading = false;
        this.$message.error('获取列表失败');
      });
    },
    // 查询按钮
    handleQuery () {
      this.queryParams.currPage = 1;
      this.getList();
    },
    // 重置按钮
    handleReset () {
      this.queryParams = {
        currPage: 1,
        pageSize: 200,
        compNames: undefined,
        usingUnit: undefined,
        houseName: undefined,
        OIDNO: undefined,
        inspectionMonthList: [],
        isPrinted: '0',
        isMailed: '0',
        ispinfoSubmitState: '0',
        receiptStatus: null,
        ispinfoSubmitTimeRange: [],
        mailingDateRange: []
      };
      this.getList();
    },
    // 表格选择改变
    handleSelectionChange (selection) {
      this.selectedRows = selection;
    },
    // 批量打印
    handleBatchPrint () {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要打印的报告');
        return;
      }

      // 提取所有选中行的委托编码
      const entrustNums = this.selectedRows.map(row => row.entrustNum).filter(num => num);

      if (entrustNums.length === 0) {
        this.$message.warning('选中的数据中没有有效的委托编码');
        return;
      }

      // 显示全屏遮罩层
      const loading = this.$loading({
        lock: true,
        text: '正在生成报告PDF，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      // 调用批量生成PDF的API，type=0表示报告
      previewTestDataPdf({ entrustNums: entrustNums, type: 0 }).then(response => {
        console.log(response);
        loading.close();

        if (response && response.retCode === 'ok' && response.additionalData) {
          // 保存当前的委托编号列表
          this.currentEntrustNums = entrustNums;
          // 设置PDF文件名并打开预览弹窗
          this.pdfFileName = response.additionalData + '.pdf';
          this.pdfPreviewVisible = true;
          this.$nextTick(() => {
            if (this.$refs.pdfImgViewer) {
              this.$refs.pdfImgViewer.init();
            }
          });
          this.$message.success('报告PDF生成成功，可以打印了');
        } else {
          this.$message.error(response.retMsg || '报告PDF生成失败');
        }
      }).catch(error => {
        console.error('生成报告PDF失败:', error);
        loading.close();
        this.$message.error('生成报告PDF失败');
      });
    },
    // 批量下载
    handleBatchDownload () {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要下载的报告');
        return;
      }

      // 提取所有选中行的委托编码
      const entrustNums = this.selectedRows.map(row => row.entrustNum).filter(num => num);

      if (entrustNums.length === 0) {
        this.$message.warning('选中的数据中没有有效的委托编码');
        return;
      }

      // 保存当前选中的委托编号列表
      this.downloadEntrustNums = entrustNums;

      // 初始化表单默认值
      this.downloadForm.isPrinted = '1';
      // 默认打印日期为当前日期
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      this.downloadForm.printDate = `${year}-${month}-${day}`;

      // 若职员列表已加载，则尝试设置默认打印人为当前登录人
      this.setDefaultPrinter();

      // 打开对话框
      this.downloadDialogVisible = true;
    },
    // 确认批量下载，携带额外参数调用接口
    confirmBatchDownload () {
      this.$refs.downloadForm.validate((valid) => {
        if (!valid) {
          return;
        }

        if (!this.downloadEntrustNums || this.downloadEntrustNums.length === 0) {
          this.$message.error('未获取到需要下载的委托编号');
          return;
        }

        this.downloadSubmitting = true;

        // 显示全屏遮罩层
        const loading = this.$loading({
          lock: true,
          text: '正在生成下载文件，请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        const params = {
          entrustNums: this.downloadEntrustNums,
          type: 0,
          isPrinted: this.downloadForm.isPrinted,
          printerEmployeePid: this.downloadForm.printerEmployeePid,
          printDate: this.downloadForm.printDate
        };

        // 调用批量下载API
        previewTestDataPdfdown(params).then(response => {
          loading.close();
          this.downloadSubmitting = false;

          // response 是 blob 对象
          if (response && response.size > 0) {
            // 创建下载链接，下载ZIP压缩包
            const blob = new Blob([response], { type: 'application/zip' });
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = `报告批量下载_${new Date().getTime()}.zip`;
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // 释放 URL 对象
            window.URL.revokeObjectURL(downloadUrl);
            this.$message.success('报告下载成功');
            this.downloadDialogVisible = false;
          } else {
            this.$message.error('下载文件为空，请检查数据');
          }
        }).catch(error => {
          console.error('下载失败:', error);
          loading.close();
          this.downloadSubmitting = false;
          this.$message.error('下载失败：' + (error.message || '未知错误'));
        });
      });
    },
    // 加载职员列表（供打印人选择使用）
    loadEmployeeList () {
      // 如果已经加载过职员列表，则不重复加载
      if (this.employeeList.length > 0 || this.employeeLoading) {
        return;
      }

      this.employeeLoading = true;
      const params = {
        pageSize: 200,
        curPage: 1
      };

      queryEmployee(params)
        .then(res => {
          if (res.dataList) {
            this.employeeList = res.dataList || [];
            // 职员列表加载完成后设置默认打印人
            this.setDefaultPrinter();
          } else {
            this.$message.error(res.retMsg || '获取职员列表失败');
            this.employeeList = [];
          }
          this.employeeLoading = false;
        })
        .catch(err => {
          this.$message.error('获取职员列表失败：' + (err.message || '网络错误'));
          this.employeeList = [];
          this.employeeLoading = false;
        });
    },
    // 根据当前登录人设置默认打印人
    setDefaultPrinter () {
      if (!this.employeeList || this.employeeList.length === 0) {
        return;
      }
      const loginUser = this.$store && this.$store.state && this.$store.state.loginUser;
      if (!loginUser || !loginUser.userPkid) {
        return;
      }
      const current = this.employeeList.find(emp => emp.employeePid === loginUser.userPkid);
      if (current) {
        this.downloadForm.printerEmployeePid = current.employeePid;
      }
    },
    // 报告邮寄登记
    handleMailingRegister () {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要邮寄的报告');
        return;
      }
      this.$refs.mailingRegister.openDialog(this.selectedRows);
    },
    // 退出按钮
    handleExit (row) {
      this.$confirm('确定要退出该报告的邮寄登记吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // TODO: 调用实际的API
        // exitMailing(row.id).then(res => {
        //   if (res && res.retCode === 'ok') {
        //     this.$message.success('退出成功');
        //     this.getList();
        //   } else {
        //     this.$message.error((res && res.retMsg) || '退出失败');
        //   }
        // }).catch(error => {
        //   console.error('退出失败:', error);
        //   this.$message.error('退出失败');
        // });

        // 模拟退出
        this.$message.success('退出成功');
        this.getList();
      }).catch(() => {
        this.$message.info('已取消退出');
      });
    },
    // 分页大小改变
    handleSizeChange (val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 当前页改变
    handleCurrentChange (val) {
      this.queryParams.currPage = val;
      this.getList();
    },
    // 更新打印信息方法(传递给子组件调用)
    handleUpdatePrintInfo (entrustNumList) {
      console.log('调用更新打印信息 API, 委托编号列表:', entrustNumList);

      return updatePrintInfo(entrustNumList).then((response) => {
        console.log('更新打印信息 API 返回结果:', response);
        return response;
      }).catch((error) => {
        console.error('更新打印信息 API 调用失败:', error);
        throw error;
      });
    }
  }
};
</script>

<style scoped>
.app-container {
  padding: 20px;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>
